import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import CameraRetroIcon from "@rsuite/icons/legacy/CameraRetro";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import Response_Loading_processing from "../../../../src/layout/Others/Response_Loading_processing";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import { toast } from "react-toastify";
import { IoMdInformationCircle } from "react-icons/io";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import { useMyContext } from "../../../components/Provider/CommonProvider";

function ProfileScreen(props) {
  const [data, setData] = useState({ profile_name: "" });
  const [profile_name, setProfile_name] = useState("");
  const [image, setImage] = useState("");
  const [imageError, setImageError] = useState("");
  const [loading, setLoading] = useState(true);
  const access_token = localStorage.getItem("access_token");
  const modalRef = useRef(null);

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  };

  const { fetchRequest, globalImageUplaodAPI } = useMyContext();
  const imageApi = globalImageUplaodAPI();

  const [withoutRefresh, setWithoutRefresh] = useState(false);
  const [editUser, setEditUser] = useState({
    profile_name: "",
    choose_profile_screen_image: "",
  });

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/admin/Choose-Profile-Screen-Setting/index
      `,
        { headers: headers }
      );
      if (response.data.status) {
        setData(response.data.ChooseProfileScene_Setting[0]);
        setEditUser(response.data.ChooseProfileScene_Setting[0]);
        setProfile_name(response.data.ChooseProfileScene_Setting[0].profile_name);
        setImage(response.data.ChooseProfileScene_Setting[0].choose_profile_screen_image);
        setLoading(false);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      // toast.error(error.message);
      setLoading(false);
    }
  };

  useEffect(async () => {
    fetchData();
  }, [withoutRefresh]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setEditUser((prevEditUser) => ({
      ...prevEditUser,
      [name]: value,
    }));
    if (name === "profile_name") {
      setValidationMessageprofile_name("");
      setIsValidationHiddenprofile_name(true);
    }
  };

  const fileInputRef1 = useRef(null);

  const [selectedFile1, setSelectedFile1] = useState(null);

  const handleFileChange = (event, fileInputRef, setSelectedFile) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    if (file) {
      setImageError("");
    }
  };

  const handleDelete = (index) => {
    switch (index) {
      case 1:
        setSelectedFile1(null);
        if (fileInputRef1.current) {
          fileInputRef1.current.value = null;
        }
        break;
      default:
        break;
    }
  };

  const [validationMessageprofile_name, setValidationMessageprofile_name] =
    useState("");
  const [isValidationHiddenprofile_name, setIsValidationHiddenprofile_name] =
    useState(true);

  const profile_nameInputRef = useRef(null);
  const [processing, setProcessing] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);

  async function handleSave() {
    let focusInputRef = null;
    let validationFailed = false;
    const trimmedProfileName = editUser?.profile_name?.trim();
    if (!trimmedProfileName) {
      setValidationMessageprofile_name("Profile Name cannot be empty.");
      setIsValidationHiddenprofile_name(false);
      focusInputRef = profile_nameInputRef;
      validationFailed = true;
    } else if (trimmedProfileName.length < 3) {
      setValidationMessageprofile_name("Profile Name must be at least 3 characters.");
      setIsValidationHiddenprofile_name(false);
      focusInputRef = profile_nameInputRef;
      validationFailed = true;
    } else if (trimmedProfileName.length > 100) {
      setValidationMessageprofile_name("Profile Name must not exceed 100 characters.");
      setIsValidationHiddenprofile_name(false);
      focusInputRef = profile_nameInputRef;
      validationFailed = true;
    } else {
      setValidationMessageprofile_name("");
      setIsValidationHiddenprofile_name(true);
    }
    const hasExistingImage = !!editUser?.choose_profile_screen_image;
    if (!selectedFile1 && !hasExistingImage) {
      setImageError("Please select an image.");
      validationFailed = true;
    } else if (selectedFile1) {
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
      if (!allowedTypes.includes(selectedFile1.type)) {
        setImageError("Only image files (jpg, jpeg, png, gif) are allowed.");
        validationFailed = true;
      } else {
        setImageError("");
      }
    } else {
      setImageError("");
    }

    if (validationFailed) {
      if (focusInputRef) {
        focusInputRef.current?.focus();
      }
      return;
    }

    const formData = new FormData();
    formData.append("profile_name", editUser?.profile_name);
    // if (selectedFile1) {
    //   formData.append("image", selectedFile1);
    // }
    const headers = {
      Authorization: "Bearer " + access_token,
      Accept: "application/json",
    };

    let firstApiStatus = false;
    let imageResponseStatus = false;
    let resultapi = null;
    setProcessing(true);
    setShowOverlay(true);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_Baseurl}/admin/Choose-Profile-Screen-Setting/update`,
        formData,
        { headers }
      );

      if (response.data.status === true) {
        firstApiStatus = true;
        resultapi = response.data;
        if (selectedFile1) {
          const formDataAdd = new FormData();
          const imageFields = [];
          formDataAdd.append('id', resultapi?.Choose_Profile_Scene_Setting?.id);
          formDataAdd.append('modelName', 'ChooseProfileScreenSetting');
          formDataAdd.append("choose_profile_screen", selectedFile1);
          imageFields.push('choose_profile_screen');
          imageFields.forEach((field) => {
            formDataAdd.append('imageFields[]', field);
          });

          const imageResponse = await fetchRequest({
            method: 'POST',
            url: imageApi,
            data: formDataAdd,
          });
          if (imageResponse?.status === true) {
            imageResponseStatus = true;
          }
        }

        setWithoutRefresh(!withoutRefresh);
      }
    } catch (error) {
      toast.error(error.message);
      setProcessing(false);
      setShowOverlay(false);
      return;
    }

    if (firstApiStatus && !selectedFile1) {
      props.setApiresponsealert(resultapi);
      props.setShowalert(true);
      toast.success(resultapi?.message)
      setWithoutRefresh(!withoutRefresh);
      setValidationMessageprofile_name("");
      setProcessing(false);
      setShowOverlay(false);

      const modal = window.bootstrap.Modal.getInstance(modalRef.current);
      modal.hide();

      setSelectedFile1(null);
      setImageError("");
    } else if (firstApiStatus && imageResponseStatus) {
      props.setApiresponsealert(resultapi);
      props.setShowalert(true);
      toast.success(resultapi?.message)
      setWithoutRefresh(!withoutRefresh);
      setValidationMessageprofile_name("");
      setProcessing(false);
      setShowOverlay(false);
      const modal = window.bootstrap.Modal.getInstance(modalRef.current);
      modal.hide();

      setSelectedFile1(null);
      setImageError("");
    } else {
      setProcessing(false);
      setShowOverlay(false);
      props.setApiresponsealert(resultapi);
      props.setShowalert(true);
      setIsValidationHiddenprofile_name(false);
    }
  }

  return (
    <>
      <div>
        {showOverlay && <Response_Processing></Response_Processing>}
      </div>
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
        ref={modalRef}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-profile_name" id="staticBackdropLabel">
                Profile Name
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setEditUser({ ...data });
                  setSelectedFile1(null);
                  setValidationMessageprofile_name("");
                  setIsValidationHiddenprofile_name(true);
                  setImageError("");
                }}
              ></button>
            </div>
            <div className="modal-body">
              <div className=" text-start">
                <p className="mandatorySimple theme-text-color mb-3 mt-0 admin-input-title d-block position-relative">Profile Name</p>
                <AdminCustomInput type="text" id="profile_name" placeHolder={"Enter Name"} name="profile_name" value={editUser?.profile_name} onChange={handleInput} ref={profile_nameInputRef} error={validationMessageprofile_name} />
              </div>

              <div className="mt-2">
                <p className="mandatorySimple theme-text-color mb-3 mt-0 admin-input-title d-block position-relative">Image</p>
                <div className="">
                  {loading ? (
                    <Response_Loading_processing />
                  ) : (
                    !selectedFile1 && editUser?.choose_profile_screen_image && (
                      <img
                        src={editUser.choose_profile_screen_image}
                        alt="choose_profile_screen_image"
                        className="thumbnails-images"
                      />
                    )
                  )}
                </div>

                <div className="col-lg-12 row mt-2">
                  <div className="col-6 col-sm-6 col-lg-6">
                    <div
                      className="imagedrop"
                      onClick={() => fileInputRef1.current.click()}
                    >
                      <input
                        type="file"
                        ref={fileInputRef1}
                        onChange={(event) =>
                          handleFileChange(
                            event,
                            fileInputRef1,
                            setSelectedFile1
                          )
                        }
                        accept="image/*"
                        style={{ display: "none" }}
                      />
                      <label>
                        <CameraRetroIcon />
                      </label>
                    </div>
                    {imageError && (<div className='d-flex align-items-center gap-1 mt-3'><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /><MessageBox text={`${imageError}`} classname='errorred  d-block' /></div>)}
                  </div>
                  <div className="col-6 col-sm-6 col-lg-6">
                    <div>
                      {selectedFile1 && (
                        <div className="imagedropcopy text-end">
                          <div className="col-lg-12 row p-0 m-0">
                            <div className=" col-sm-10 col-lg-10 p-0 m-0">
                              <img
                                src={URL.createObjectURL(selectedFile1)}
                                alt="Uploaded"
                                className="thumbnails-upload-images"
                              />
                            </div>
                            <div
                              className="col-sm-2 col-lg-2 p-0 m-0"
                              style={{ alignSelf: "center" }}
                            >
                              <button
                                onClick={() => handleDelete(1)}
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                              ></button>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              {/* <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button> */}
              <button
                type="button"
                className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3"
                onClick={handleSave}
              >
                Update Settings
              </button>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className=" m-0 p-0">
          <div className="">
            <section className="container-fluid">
              <div className="col-lg-12 row py-3">
                <div className="col-6 col-sm-6 col-lg-6">
                  <h3>Profile Image Settings</h3>
                </div>
                <div className="col-6 col-sm-6 col-lg-6">
                  <div className="text-end">
                    <button
                      data-bs-toggle="modal"
                      data-bs-target="#staticBackdrop"
                      className="button-bg-color theme-button-text-color admin-button-text rounded-3 py-2 px-3"
                      onClick={() => {
                        setEditUser({ ...data });
                        setSelectedFile1(null);
                        setValidationMessageprofile_name("");
                        setIsValidationHiddenprofile_name(true);
                        setImageError("");
                      }}
                    >
                      Update Image
                    </button>
                  </div>
                </div>
              </div>

              <div className="row col-lg-12 ">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                  <div className="card p-3">
                    <MessageHeading text={"Screen Image"} />

                    <div className=" text-start">
                      <MessageLabel text={data?.profile_name || "Add Profile Name"} />
                      <div className="mt-2">
                        {loading ? (
                          <Response_Loading_processing />
                        ) : editUser?.choose_profile_screen_image ? (
                          <img
                            src={editUser.choose_profile_screen_image}
                            alt="Profile"
                            className="thumbnails-images"
                          />
                        ) : (
                          <span>Upload Image</span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProfileScreen;